import React, { useState } from "react";
import styles from "./EditAllergen.module.css";
import HeaderComponent from "../../../../../components/HeaderComponent/HeaderComponent";
import {
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import HeadingComponent from "../../../../../components/HeadingComponent/HeadingComponent";
import { List } from "antd";
import { useNavigate } from "react-router-dom";

const EditAllergen = () => {
  const navigate = useNavigate();
  const [Name, setName] = useState("");
  const [Item, setItem] = useState("");
  const [ItemArray, setItemArray] = useState([]);

  const options = [
    { id: 1, name: "Mixing" },
    { id: 2, name: "Assembly" },
    { id: 3, name: "Proofing" },
    { id: 4, name: "Chilling" },
    { id: 5, name: "Oven" },
    { id: 6, name: "Packaging" },
    { id: 7, name: "Make Up" },
  ];
  const [focused, setFocused] = useState(options[0]);

  const handleAddItem = () => {
    if (Item.trim() !== "") {
      setItemArray((prev) => [...prev, { name: Item }]);
      setItem("");
    }
  };

  const handleRemove = (item) => {
    setItemArray(ItemArray.filter((el) => el?.name !== item?.name));
  };

  console.log("Item ---> ", Item);

  const renderOverview = (item, index) => {
    return (
      <div className={styles.ProductContainer}>
        <div className={styles.Box}>
          <TextComponent
            text={item?.name}
            fontFamily={"Poppins-regular"}
            color={"#808080"}
          />
        </div>
        <SubmitButton
          title={"Remove"}
          secondary
          btnContainerClass={styles.RemovebtnContainer}
          btnClass={`${styles.Removebtn}`}
          onClick={() => handleRemove(item)}
        />
      </div>
    );
  };

  console.log("ItemArray --- > ", ...ItemArray);

  return (
    <div className={styles.mainCont}>
      <div className={styles.HeadingDiv}>
        <HeaderComponent heading={"Edit Allergen"} showBackIcon={true} />
      </div>

      <div className={styles.subMainCont}>
        <div className={styles.subCont}>
          <InputField
            className={styles.inputNew}
            label={"Allergen Name"}
            placeholder={"Peanut"}
            value={Name}
            onChange={(e) => setName(e.target.value)}
          />

          <HeadingComponent
            padding={"0px"}
            text={"Concerned Stations"}
            fontSize={16}
          />

          <div className={`${styles.TopTabList} `}>
            {options?.map((tab) => {
              return (
                <div
                  key={tab.id}
                  onClick={() => setFocused(tab)}
                  className={`${styles.tab}   ${
                    focused?.name == tab.name ? `${styles.active} ` : ""
                  }`}
                >
                  <TextComponent
                    text={tab.name}
                    className={`${styles.tabText}   ${
                      focused?.name == tab.name ? `${styles.active} ` : ""
                    }`}
                  />
                </div>
              );
            })}
          </div>
          <div className={styles.InputRow}>
            <InputField
              className={styles.AddInput}
              inputStyle={{ marginTop: "0px" }}
              placeholder={"Peanut"}
              value={Item}
              onChange={(e) => setItem(e.target.value)}
            />

            <SubmitButton
              title={"Add"}
              primary
              btnContainerClass={styles.AddbtnContainer}
              btnClass={`${styles.Addbtn}`}
              onClick={handleAddItem}
            />
          </div>

          <List
            dataSource={ItemArray}
            renderItem={renderOverview}
            style={{ marginTop: 10 }}
            grid={{
              gutter: [0, 24],
              xs: 1,
              sm: 1,
              md: 1,
              lg: 1,
              xl: 1,
              xxl: 1,
            }}
          />

          <SubmitButton
            title={"Edit Allergen"}
            primary
            btnContainerClass={styles.SavebtnContainer}
            btnClass={`${styles.Savebtn}`}
            onClick={() => navigate("/AdminProductManagement/AllerganManagement")}
          />
        </div>
      </div>
    </div>
  );
};

export default EditAllergen;
